<template>
  <v-skeleton-loader
      v-bind="attrs"
      :type="type"
  ></v-skeleton-loader>
</template>

<script>
export default {
  name: "ConceptsTreeSkeletonLoader",

  data: () => ({
    attrs: {
      class: 'concepts-tree-skeleton-loader',
    },
    type: "text, text, text, text, text, text, text, text, text, text, text, text, text, text"
  }),
}
</script>

<style lang="scss">
.concepts-tree-skeleton-loader {
  padding-left: 15px !important;

  .v-skeleton-loader__bone {
    margin-bottom: 15px !important;
    height: 25px !important;
  }
}
</style>